var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "inview",
          rawName: "v-inview:enter",
          value: _vm.comesToViewport,
          expression: "comesToViewport",
          arg: "enter"
        },
        {
          name: "inview",
          rawName: "v-inview:leave",
          value: _vm.leavesViewport,
          expression: "leavesViewport",
          arg: "leave"
        }
      ],
      staticClass: "job-results--item"
    },
    [
      _c("div", { staticClass: "job-results--item-head" }, [
        _c("div", [
          _c(
            "a",
            {
              staticClass: "job-results--item--title",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openVitaFan.apply(null, arguments)
                }
              }
            },
            [_vm._v("\n\t\t\t\t" + _vm._s(_vm.applicantName) + "\n\t\t\t")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "job-list-item-more-infos" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openVitaFan.apply(null, arguments)
                }
              }
            },
            [_vm._v("mehr Infos")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        !_vm.loadedMatching
          ? _c(
              "div",
              { staticClass: "job-results--item--loading-placeholder" },
              [_c("div", [_vm._v(" ")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { class: { "d-none": !_vm.loadedMatching } },
          [
            _c("Matching", {
              attrs: {
                "job-profile-id": _vm.jobProfile.id,
                "job-id": _vm.jobId,
                applicant: _vm.applicant,
                "in-viewport": _vm.inViewport,
                "narrow-label": ""
              },
              on: {
                loaded: function($event) {
                  _vm.loadedMatching = true
                },
                click: _vm.openVitaFan
              }
            }),
            _vm._v(" "),
            _vm.localApplicant
              ? _c(
                  "div",
                  { staticClass: "job-list-item-actions" },
                  [
                    !_vm.localApplicant.communication.hasOngoingConversation
                      ? _c("Button", {
                          staticClass: "mr-2",
                          attrs: { text: "Jetzt kontaktieren", secondary: "" },
                          on: { click: _vm.contactNow }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Actions", {
                      attrs: {
                        "job-profile-list-item": _vm.jobProfileListItem,
                        applicant: _vm.localApplicant,
                        "job-id": _vm.jobId,
                        permissions: _vm.permissions
                      },
                      on: {
                        applicantChanged: function($event) {
                          _vm.localApplicant = _vm.applicant
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }